<template>
    <div class="modify_style">
        <div class="title_style">修改密码</div>
        <div class="divider"></div>
        <div class="pass_style">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
                     class="demo-ruleForm">
                <el-form-item label="旧密码" prop="oldPass">
                    <el-input type="password" v-model="ruleForm.oldPass" autocomplete="new-password" placeholder="请输入旧密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="pass">
                    <el-input type="password" v-model="ruleForm.pass" autocomplete="new-password" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="checkPass">
                    <el-input type="password" v-model="ruleForm.checkPass" autocomplete="new-password" placeholder="请确认新密码"></el-input>
                </el-form-item>
                <el-form-item v-if="$_auth('editPwd_list')">
                    <div class="button_style">
                        <el-button class="btnNew btnAll" @click="submitForm('ruleForm')">保 存</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import API from '../../../fetch/api.js'

    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入新密码'));
                } else {
                    if (this.ruleForm.checkPass !== '') {
                        this.$refs.ruleForm.validateField('checkPass');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.pass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    oldPass: '',
                    pass: '',
                    checkPass: '',
                },
                rules: {
                    oldPass: [
                        {required: true, message: '请输入旧密码', trigger: 'blur'},
                    ],
                    pass: [
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    checkPass: [
                        {validator: validatePass2, trigger: 'blur'}
                    ],
                }
            }
        },
        mounted() {

        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const val = {
                            oldPassword: this.ruleForm.oldPass,
                            newPassword: this.ruleForm.pass
                        };
                        API.http({
                            fullUrl: '/merchant/modify_pass',
                            params: val,
                            type: "post",
                        }).then(res => {
                            if (res.code === 200) {
                                this.$notify({
                                    title: '成功',
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.returnBut()
                            } else {
                                this.$notify.error({
                                    title: '错误',
                                    message: res.message,
                                });
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .modify_style {
        background: white;
        padding-bottom: 200px;

        .pass_style {
            width: 40%;
            margin-left: 28%;
        }

        .button_style {
            text-align: center;
            margin-top: 20%;
            margin-right: 8%;
        }

        .title_style {
            font-size: 18px;
            color: #1AB394;
            font-weight: 500;
            padding: 10px 0 10px 20px;
        }

        .divider {
            width: 100%;
            height: 1px;
            margin-bottom: 40px;
            background-color: #E7EAEC;
        }
    }
</style>

<style lang="scss">
    .modify_style {
        .el-form-item__label:before {
            content: '*';
            color: #F56C6C;
            margin-right: 4px;
        }
    }
</style>